import defaultImage from 'src/app/images/placeholders/show-course.jpg';
import { useEffect, useRef, useState } from 'react';
import PreVisualizeModal from './PreVisualizeModal';
import { t } from 'i18next';
import { ReactComponent as Stars } from './img/stars.svg';
import toast from 'react-hot-toast';
import { useClient } from 'jsonapi-react';
import ActionCableConsumer from '@/app/utils/actionCableConsumer';

const StepImage = props => {
  const { step, handleChangeImage, file, form, courseId } = props;
  const [webhookNotification, setWebhookNotification] = useState(null);
  const [channel, setChannel] = useState(null);
  const [requestId, setRequestId] = useState(null);
  const loadingToastRef = useRef(null);
  const [fileUrl, setFileUrl] = useState(null);

  const client = useClient();

  const [showModal, setShowModal] = useState(false);

  const handleCreateByAI = () => {
    const title = form?.values?.title;
    const getImage = client.mutate(`generate_image?format=base64&title=${title}`);

    if (!loadingToastRef.current) {
      loadingToastRef.current = toast.loading('Nossa IA está gerando a melhor imagem');
    }

    getImage
      .then(response => {
        setChannel(response.data.channel);
        setRequestId(response.data.request_id);
      })
      .catch(error => {
        toast.error('Erro ao gerar imagem', { id: loadingToastRef.current });
        loadingToastRef.current = null;
      });
  };

  const handleReceivedNotification = data => {
    setWebhookNotification(data);
  };

  useEffect(() => {
    if (!webhookNotification) return;

    if (!loadingToastRef.current) return;

    if (webhookNotification.event === 'failed') {
      toast.error('Erro ao gerar a imagem. Tente novamente mais tarde.', { id: loadingToastRef.current });
    } else if (webhookNotification.event === 'completed') {
      setFileUrl(webhookNotification.file_url);
    }
    setWebhookNotification(null);
    setChannel(null);
    setRequestId(null);
  }, [webhookNotification]);

  async function fetchImageAsBase64(url) {
    const res = await fetch(url);
    if (!res.ok) throw new Error('Falha ao baixar imagem');

    const blob = await res.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  useEffect(() => {
    return () => {
      if (loadingToastRef.current) {
        toast.dismiss(loadingToastRef.current);
        loadingToastRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    if (step !== 'imagem') {
      setFileUrl(null);
      toast.dismiss();
      loadingToastRef.current = null;
    }
  }, [step]);

  useEffect(() => {
    if (fileUrl) {
      fetchImageAsBase64(fileUrl).then(base64Image => {
        form.setFieldValue('image', base64Image);
        toast.success('Imagem gerada com sucesso!', { id: loadingToastRef.current });
        loadingToastRef.current = null;
      });
    }
  }, [fileUrl]);

  return (
    step === 'imagem' && (
      <div className="mb-12">
        {channel && requestId && (
          <ActionCableConsumer
            channel={channel}
            setObjectChannel={handleReceivedNotification}
            channelKey={'request_id'}
            channelId={requestId}
          />
        )}
        <div className="page__content mb-4 animate-fade-in">
          <div className="new-questions__header">
            <h2 className="new-questions__title">{t('courses.buttonNewCourse')}</h2>
          </div>

          <fieldset className="form__row">
            <div className="form__ai-banner mb-12">
              <h3 className="form__ai-banner-title">Nossa IA te ajuda com a imagem</h3>
              <button
                className="btn btn--small btn--review"
                type="button"
                onClick={() => handleCreateByAI()}
              >
                <Stars className="btn__icon challenge-success__stars challenge-success__stars--icon" />
                Criar com ajuda da T.I.A
              </button>
            </div>

            <legend className="form__label">{t('courses.coverImage')} (1020x252 pixels)</legend>

            <label className="form__custom-file-input">
              <input
                type="file"
                name="image"
                id="image"
                accept=".jpeg, .png, .jpg"
                onChange={handleChangeImage}
                // defaultValue={}
              />
              <span className="form__control">{false ? '' : t('textsCommon.placeholderUploadImage')}</span>
            </label>
          </fieldset>

          <div className="card__header-img-wrapper">
            <img
              className="card__header-img"
              src={form?.values?.image || file || defaultImage}
              alt="imagem do curso"
              style={{ height: '160px' }}
            />
          </div>

          <PreVisualizeModal
            courseId={courseId}
            form={form}
            show={showModal}
            onClose={() => setShowModal(false)}
            src={form?.values?.image || file || defaultImage}
          />
        </div>

        <button
          type="button"
          className="btn btn--link btn--wide"
          onClick={() => setShowModal(true)}
        >
          {t('courses.previewCourse')}
        </button>
      </div>
    )
  );
};

export default StepImage;
